import React from 'react';

// This is a handy way to dynamically pass in an icon type and add styling.

const Icon = ({ type, style = '', className = '' }) => {
  const IconElement = type;
  if (!IconElement) return null;

  if (className && !style) {
    style = className;
  }

  // We can't render inline SVGs for our jest tests, so this conditional checks
  // if IconElement is a mock.

  if (IconElement.default === 'svg-mock') {
    return IconElement;
  }
  return <IconElement className={style} />;
};

export default Icon;
